import Store from 'app/store'
import Vue from "vue"

import subdomains from './../router/subdomains.js'
import externaldomains from './../router/externaldomains.js'

export default {

	computed: {

        $subdomain: function() {

			var host = false

            if (process.env.VUE_APP_TYPE === 'externaldomain') {

				var externaldomain = false
                    
              	host = window.location.hostname

               	externaldomain = host

                if(externaldomains[externaldomain]) {

                    return externaldomains[externaldomain]

                } else {

                    return false

                }

            } else if (process.env.VUE_APP_TYPE === 'subdomain') {

				var subdomain = false
                    
               	host = window.location.hostname
                var parts = host.split('.')

                if (parts.length > 2) {
                    subdomain = parts[0].toLowerCase()
                }

				if (process.env.VUE_APP_ENV === 'development') {

					subdomain = 'binder'

				}

                if(subdomains[subdomain]) {

                    return subdomains[subdomain]

                } else {

                    return false

                }

            } else {

                return false

            }

        },

		$isDesktop: function() {

			return this.window.is.desktop || this.window.is.smalldesktop

		},

		$isSmallDesktop: function() {

			return this.window.is.smalldesktop

		},

		$isMobile: function() {

			return this.window.is.mobile

		},

		$path: function() {

			return this.$route.path

		},

		isProfile: function() {

			return this.$route.name !== 'Home'

		},

		isSelf: function() {

			return this.$isSelf

		},

		$isSelf: function() {

			return (Store.getters['session/user/id'] === Store.getters['context/id']) && Store.getters['context/is/user']

		},

		isUser: function() {

			return Store.getters['context/is/user']

		},

		isGroup: function() {

			return Store.getters['context/is/group']

		},

		isBuddies: function() {

			return Store.getters['context/is/buddies']

		},

		isGroupOrBuddies: function() {

			return Store.getters['context/is/buddies'] || Store.getters['context/is/group']

		},

		hasMe: function() {

			return Store.getters['permissions/is/member'] || Store.getters['permissions/is/owner']

		},

		isOwner: function() {

			return Store.getters['permissions/is/owner']

		},

		isMember: function() {

			return Store.getters['permissions/is/member']

		},

		loggedin: function() {

			return Store.getters['session/loggedin']

		},

		$loggedin: function() {

			return Store.getters['session/loggedin']

		},

		$isPatreon: function() {

			return (this.$loggedin) ? Store.getters['session/patreon'] : false

		}

	},

	methods: {

		$vueset: function(a, b, c) {

			Vue.set(a, b, c)

		},

		$vueremove: function(a, b) {

			Vue.delete(a, b)

		},

		$hasEarly: function(name) {

			if(this.isUser) {

				return this.$_.contains(Store.getters['context/early'], name)

			} else {

				return false

			}

		},

		$routerPush: function(e) {

            if (process.env.VUE_APP_TYPE === 'subdomain' || process.env.VUE_APP_TYPE === 'externaldomain') {

				if (e.params) {

                    if (e.params.type) {

						if (this.$subdomain.type !== e.params.type || this.$subdomain.name !== e.params.name) {

							window.location.href = 'https://geekgroup.app/' + e.params.type + '/' + e.params.name

						} else {

							this.$router.push(e)

						}

					} else {

						this.$router.push(e)
						
					}

                } else {

                    this.$router.push(e)

                }

			} else {

				this.$router.push(e)

			}

		},

		$notify: function(config) {

			if (this.$_.isArray(config.message)) config.message = config.message.join(' ')

			config.message = config.message.replace(' .', '.')

			Vue.$toast.open(config)

		},

		formatcurrency: function(value, decimals, pure) {

			return this.$options.filters.currency(Math.abs(value), decimals, pure)

		},

		$filter: function(name, value, param) {

			return this.$options.filters[name](value, param)

		}

	}

}